import { FC } from "react";
import { Button } from "react-bootstrap";
import FontFa from "../../fontFa/fontFa";
import useExportDocxFile from "../../../pages/procedure/company-office/request-vehicle/TemplateDocx/useExportDocxFile";

type props = {
  isRefund?: boolean;
  isHideRefund?: boolean;
  value: any;
};
const DownloadPassport: FC<props> = (props) => {
  const { isRefund, isHideRefund } = props;

  const passport2 = useExportDocxFile({ item: props.value, docType: 3 });
  const doc31 = useExportDocxFile({ item: props.value, docType: 31, isViags: false });
  const doc32 = useExportDocxFile({ item: props.value, docType: 31 });

  return (
    <>
      {isRefund || (
        <>
          <Button
            title={"Xuất Giấy đi đường"}
            className="ml-2"
            variant="outline-info"
            onClick={(e: any) => {
              e.stopPropagation();
              passport2.exportForm(props.value);
            }}
          >
            <FontFa name="faFileWord" size={"2x"} />
          </Button>

          <Button
            title={"Xuất phiếu yêu cầu xuất vé"}
            className="ml-2"
            variant="outline-success"
            onClick={(e: any) => {
              e.stopPropagation();
              doc31.exportForm(props.value);
            }}
          >
            <FontFa name="faTicketAlt" size={"2x"} />
          </Button>
        </>
      )}

      {!isHideRefund && (
        <Button
          title={"Xuất phiếu yêu cầu hoàn vé"}
          className="ml-2"
          variant="outline-warning"
          onClick={(e: any) => {
            e.stopPropagation();
            doc32.exportForm(props.value);
          }}
        >
          <FontFa name="faTicketAlt" size={"2x"} />
        </Button>
      )}
    </>
  );
};

export default DownloadPassport;
